// (c) TwistedMinds, Gerry Uytdenhouwen - 5 november 2026

const clean = (value) => (value === null || value === undefined ? '' : String(value).trim());

/**
 * Compares the stored profile with the edited one.
 * Values are trimmed; e-mail addresses are compared case-insensitively.
 *
 * @param {{name: string, email: string, phone: string}} original
 * @param {{name: string, email: string, phone: string}} edited
 * @returns {{changed: boolean, emailChanged: boolean}}
 */
export const profileChanges = (original, edited) => {
    const emailChanged = clean(original.email).toLowerCase() !== clean(edited.email).toLowerCase();
    const changed = emailChanged
        || clean(original.name) !== clean(edited.name)
        || clean(original.phone) !== clean(edited.phone);
    return {changed, emailChanged};
};
